import React from "react";

import { initializeIcons } from "office-ui-fabric-react/lib/Icons";
import { Card, CardBody, CardHeader } from "reactstrap";



import { AntragstellerFirmaOPSConsts, SpannungsebeneOPSConsts } from "../TempConstantsCommon";

import logo from "./assets/NetzanschlussStromnetzLogo.png";
import AntragHeader from "../../common/components/request/AntragHeader";
import StromnetzeRequest from "./components/request/StromnetzeRequest";
import { FormFieldsCommon } from "../../common/CommonConstants";
import { FormFieldsSN } from "./components/request/StromnetzeRequestConstants";


const paramNameAutoComplete = "autoC";
const paramNameNoSubmit = "noS";
const paramNameNoFormDisable = "noFD";

class Stromnetz extends React.Component {

  private _autoCompleteMode: string;
  private _noSubmit: boolean;
  private _noFormDisable: boolean;

  constructor(props: any) {
    super(props);

    initializeIcons();

    const params = new URLSearchParams(window.location.search);

    this._autoCompleteMode = params.has(paramNameAutoComplete) ? "on" : "new-password";
    this._noSubmit = params.has(paramNameNoSubmit);
    this._noFormDisable = params.has(paramNameNoFormDisable);

    debugger;
  }

  render() {
    return (
      <React.Fragment>
        <Card
          style={{ maxWidth: "1440px", margin: "20px auto" }}
        >
          <CardHeader>
            <AntragHeader 
              caption="Anfrage auf technische Prüfung Netzanschluss Stromnetz" 
              logo={logo}
              // logo={null}
            />
          </CardHeader>
          <CardBody
            style={{ padding: 22 }} 
          >
            <StromnetzeRequest
              formFields={FormFieldsCommon.concat(FormFieldsSN)}
              companies={AntragstellerFirmaOPSConsts}
              voltages={SpannungsebeneOPSConsts}
              autoCompleteMode={this._autoCompleteMode}
              noSubmit={this._noSubmit} 
              noFormDisable={this._noFormDisable}
            />              
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default Stromnetz;
